import { computed, getCurrentInstance } from 'vue';

type CurrentInstance = NonNullable<ReturnType<typeof getCurrentInstance>>;

const vuetify = computed(() => ((getCurrentInstance() as CurrentInstance).proxy as any).$vuetify);

export default vuetify;
